/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import { useIntl } from 'react-intl'

export const MIELFLOW_WEBSITE = 'https://www.mielflow.com'
export const PRIVACY_POLICY_PATH = `${process.env.PUBLIC_URL || ''}/privacy-policy`

const Footer = () => {
  const intl = useIntl();
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])

  const companyName = process.env.REACT_APP_COMPANY_NAME
  
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {new Date().getFullYear().toString()}&copy;
        </span>
        <a
          href={MIELFLOW_WEBSITE}
          target='_blank'
          rel='noopener noreferrer'
          className='text-gray-800 text-hover-primary'
          data-testid='footer-brand'
        >
          {companyName}
        </a>

        <span style={{ marginLeft: '10px' }}>
          {/* Absolute: the relative 'privacy-policy' resolved against the
              current page, so from /order-management/orders it led nowhere. */}
          <a
            href={PRIVACY_POLICY_PATH}
            target='_blank'
            rel='noopener noreferrer'
            className='text-gray-800 text-hover-primary'
            data-testid='footer-privacy'
          >
            {intl.formatMessage({ id: 'AUTH.LOGIN.PRIVACY_POLICY' })}
          </a>
        </span>
      </div>

      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'></ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
